module.exports = __webpack_public_path__ + "static/img/logo-aaga-light.6504762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand/logo-aaga-light.png
// module id = dQLz
// module chunks = 71